export default {
  ecoBlockAnchor: {
    id: 'product_page_ecoblock_anchor',
    defaultMessage: 'More sustainable than new',
  },
}
